<template>
  <v-layout
    row
    xs12
    class="filter-table-data"
    :class="{combo : combo}"
  >
    <v-flex xs12>
      <v-text-field
        v-if="!combo"
        :value="wartosc"
        @input="updateData"
        full-width
        solo
        :disabled="selectedType == 'empty' || selectedType == 'not_null' || selectedType == 'empty' || selectedType == 'not_null'"
        :label="label()"
      ></v-text-field>
      <v-select
        v-else
        full-width
        solo
        clearable
        append-icon="filter_list"
        :value="wartosc"
        :items="comboItems"
        label="Wybierz"
        @input="updateData"
      ></v-select>
    </v-flex>
    <v-flex
      p
      v-if="!combo"
    >
      <v-menu offset-y>
        <v-btn
          flat
          icon
          depressed
          small
          slot="activator"
          style="padding-left:8px;"
        >
          <v-icon small>filter_list</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="(item, key) in menuItems"
            :key="key"
            @click="selectedType = key; updateData(wartosc)"
            :value="key == selectedType"
            active-class="primary primary--text text--lighten-4"
          >
            <v-list-tile-title>{{ item.text }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from "moment";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import map from "lodash/map";
import filter from "lodash/filter";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import some from "lodash/some";
//import isArray from "lodash/isArray";
import each from "lodash/each";
import endsWith from "lodash/endsWith";
mixin(_, {
  map,
  filter,
  includes,
  isEmpty,
  some,
  //isArray,
  each,
  chain,
  endsWith
});
_.value = value;
_.prototype.value = value;

export default {
  components: {

  },
  props: {
    value: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    combo: {
      type: Boolean,
      required: false,
      default: false
    },
    comboItems: {
      type: Array,
      required: false,
      default: []
    }
  },
  data: () => ({
    wartosc: '',
    selectedType: '',
    ignore: false,
  }),
  computed: {
    menuItems() {
      //dictionary ->combo

      const items = {
        eq: {
          text: 'Równa się'
        },
        not_eq: {
          text: 'Nie równa się'
        },
        null: {
          text: 'Nie wypełnione'
        },
        not_null: {
          text: 'Wypełnione'
        }
      };

      if(this.type === 'string') {//text
        items.contains = {
          text: 'Zawiera się'
        };
        items.not_contains = {
          text: 'Nie zawiera się'
        };
        items.empty = {
          text: 'Puste'
        };
        items.not_empty = {
          text: 'Nie puste'
        };
        items.start_with = {
          text: 'Zaczyna się'
        };
        items.not_start_with = {
          text: 'Nie zaczyna się'
        };
        items.end_with = {
          text: 'Kończy się'
        };
        items.not_end_with = {
          text: 'Nie kończy się'
        };
      } else if(this.type === 'datetime' || this.type === 'date') {//date
        items.lt = {
          text: 'Wcześniej niż'
        };
        items.lte = {
          text: 'Wcześniej i równe niż'
        };
        items.gt = {
          text: 'Później niż'
        };
        items.gte = {
          text: 'Później i równe niż'
        };
      } else if(this.type === 'integer' || this.type === 'real') {//number
        items.lt = {
          text: 'Mniejsze niż'
        };
        items.lte = {
          text: 'Mniejsze i równe niż'
        };
        items.gt = {
          text: 'Wieksze niż'
        };
        items.gte = {
          text: 'Wieksze i równe niż'
        };
      }

      return items;
    },
  },
  watch: {
    value() {
      this.fromBase();
    },
  },
  created() {
    this.fromBase();
    moment.locale("pl");
  },
  methods: {
    fromBase() {
      this.ignore = true;
      this.wartosc = this.value.value ? `${this.value.value}` : '';
      this.selectedType = this.value.type || 'eq';
      this.ignore = false;
    },
    convertValue(value) {
      //console.log('convertValue 1', value, typeof value);

      if(this.type === 'string') {//text
        value = `${value}`;
      } else if(this.type === 'datetime' || this.type === 'date') {//date
        //value = moment(value);
      } else if(this.type === 'integer' || this.type === 'real') {//number
        value = value ? +value : '';
      }

      //console.log('convertValue 2', value, typeof value);
      return value;
    },
    updateData($event) {
      let value = $event;
      if(_.endsWith(this.selectedType, 'empty')) {
        value = '';
      }
      if(_.endsWith(this.selectedType, 'null')) {
        value = '';
      }
      this.$emit('input', {
        value: this.convertValue(value),
        type: this.selectedType
      });
    },
    label() {
      if(this.selectedType === 'empty') {
        return 'Puste';
      } else if(this.selectedType === 'not_empty') {
        return 'Nie puste';
      } else if(this.selectedType === 'null') {
        return 'Nie wypełnione';
      } else if(this.selectedType === 'not_null') {
        return 'Wypełnione';
      } else {
        return '';
      }
    }
  }
};
</script>

<style>
.filter-table-data {
  margin-left: -24px;
  width: calc(100% + 48px) !important;
  height: 32px;
}
.filter-table-data.combo {
  width: calc(100% + 40px) !important;
}
.filter-table-data .v-input__control {
  padding: 0px !important;
  min-height: 10px !important;
}
.filter-table-data .v-input__control .v-input__slot {
  margin-bottom: 0px !important;
  min-height: 0px;
}
.filter-table-data .v-input__control .v-text-field__slot input {
  margin-top: 0px;
}
.filter-table-data .v-menu {
  margin-left: -34px;
  margin-top: -3px;
}
</style>



// WEBPACK FOOTER //
// src/components/viewer/edition/components/VInputFilter.vue